'use client';

import { NavLink } from '@/components/ui/nav-link';
import { dividerMotion, textRevealMotion } from '@/utils/animations';
import { motion } from 'motion/react';

interface Props {
  index: number;
  link: string;
  label: string;
}

export function OverlayMenuItem({ index, link, label }: Props) {
  return (
    <motion.li
      tabIndex={-1}
      initial="initial"
      animate="animate"
      whileTap="hover"
      whileHover="hover"
      whileFocus="hover"
      variants={textRevealMotion(index * 0.125 + 0.4)}
    >
      <NavLink href={link} className="relative text-3xl sm:text-5xl md:text-6xl select-none">
        {label}
        <motion.span variants={dividerMotion} className="absolute bottom-0 w-full left-0 h-[2px] bg-black dark:bg-white origin-left" />
      </NavLink>
    </motion.li>
  );
}
